import apis from '@api/client';
import { useQuery } from '@tanstack/react-query';

export function useGetEmployeeQuery(employeeId: string) {
  return useQuery({
    queryKey: [apis.me.getMyEmployee.name, employeeId],
    queryFn: () => apis.me.getMyEmployee({ employeeId }).then(res => res.data),
    enabled: !!employeeId,
  });
}
